<template>
  <input
    :id="id"
    :type="type"
    :name="name"
    :placeholder="placeholder"
    v-model="value"
    @focus="event => emit('focus', event)"
    @blur="event => emit('blur', event)"
  />
</template>

<script setup>
import { watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useField } from 'vee-validate';

const store = useStore();

const props = defineProps({
  id: { type: String, require: false },
  name: { type: String, require: true },
  type: { type: String, default: 'text' },
  placeholder: { type: String },
  validator: { type: Object, required: true },
  dispatcher: { type: String, required: true }
});

const emit = defineEmits(['focus', 'blur']);

const initialValue = computed(
  () =>
    store.state[props.name] ||
    (store.state.formData && store.state.formData[props.name]) ||
    (store.state.positionInquiryMail &&
      store.state.positionInquiryMail.formData[props.name])
);

const { value } = useField(props.name, props.validator, {
  validateOnMount: false,
  initialValue: initialValue.value
});

watch(value, newValue => store.dispatch(props.dispatcher, newValue));
</script>
